import type { AnalyticsSender, Offer } from '@funtech-int/yango-shared';

import {
    channelPageChannelNavigated,
    ChannelPageChannelNavigatedTo,
    channelPageChannelShowed,
    channelPageNavigatedV2,
    ChannelPageNavigatedV2To,
    channelPageShowed,
    channelPageSubscriptionOfferNavigatedV2,
    channelPageSubscriptionOfferShowedV2,
    channelPageSubscriptionOfferSucceedV2,
} from '@kinopoisk-int/evgen-web-events/web/channel_page';
import { ChannelPageOfferEntityTypes } from '@kinopoisk-int/evgen-web-events/web/named_enums';

import { TARIFFICATOR_BILLING_PRODUCT_ID } from '@/shared/lib/analytics/offer';

import { transformOfferText } from './utils/transformOfferText';

export const createAnalyticsEvents = (eventSender: AnalyticsSender) => ({
    cardShowed(contentId: string, channelName: string, programName: string) {
        eventSender.sendOnce(channelPageChannelShowed, {
            title: programName ?? '-',
            uuid: contentId ?? '-',
            channelName: channelName ?? '-',
        });
    },
    cardClicked(contentId: string, channelName: string, programName: string) {
        eventSender.send(channelPageChannelNavigated, {
            title: programName ?? '-',
            uuid: contentId ?? '-',
            channelName: channelName ?? '-',
            to: ChannelPageChannelNavigatedTo.PlayerScreen,
        });
    },
    channelNavigated() {
        eventSender.send(channelPageNavigatedV2, {
            to: ChannelPageNavigatedV2To.PlayerScreen,
        });
    },

    channelShowed() {
        eventSender.send(channelPageShowed, {});
    },

    navigatedToChannelList() {
        eventSender.send(channelPageNavigatedV2, {
            to: ChannelPageNavigatedV2To.ChannelListScreen,
        });
    },

    createOfferAnalyticsEvents(
        offer: Offer | null | undefined,
        buttonText: string,
        channelName: string,
        channelId: string
    ) {
        const catalogCompositeOffer = offer?.catalogCompositeOffer;
        const tariffOffer = catalogCompositeOffer?.tariffOffer;
        const optionOffers = catalogCompositeOffer?.optionOffers || [];
        const firstOptionOffer = optionOffers?.[0];

        const offerTexts = offer?.offerTexts;

        const tariffName = tariffOffer?.tariff?.name;
        const optionName = firstOptionOffer?.option?.name;

        const text = buttonText ?? offerTexts?.buttonText;

        const eventOfferMeta = {
            entityType: ChannelPageOfferEntityTypes.SubscriptionOption,
            offerTitle: transformOfferText({
                offerText: text,
                additionalText: offerTexts?.buttonTextWithDetails,
            }),
            buttonText: text,
            billingProductId: TARIFFICATOR_BILLING_PRODUCT_ID,
            billingProductIds: offer?.billingProductIds || 'NONE',
            offerTariffName: tariffName || 'NONE',
            offerOptionNames: optionName || 'NONE',
            position: 1,
            title: channelName || '',
            uuid: channelId,
        };

        return {
            showed() {
                eventSender.send(channelPageSubscriptionOfferShowedV2, {
                    ...eventOfferMeta,
                    uuid: channelId ?? '-',
                    show: offer?.offerPositionsData ?? {},
                });
            },
            navigated() {
                eventSender.send(channelPageSubscriptionOfferNavigatedV2, {
                    ...eventOfferMeta,
                    uuid: channelId ?? '',
                    show: offer?.offerPositionsData ?? {},
                    click: offer?.offerPositionsData ?? {},
                });
            },
            succeeded() {
                eventSender.send(channelPageSubscriptionOfferSucceedV2, {
                    ...eventOfferMeta,
                    uuid: channelId ?? '',
                    show: offer?.offerPositionsData ?? {},
                });
            },
        };
    },
});
